import { CSSProperties, useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import { signIn } from "next-auth/react";
import { useTranslations } from "next-intl";
import { useMediaQuery } from "react-responsive";
import { OverlayTriggerHandle } from "rsuite/esm/internals/Overlay/OverlayTrigger";
import { useSolutionsSelect } from "@/states/solution.state";
import { useSignUpModal } from "@/states/ui.state";
import { useRegisterTrack, useUserState } from "@/states/user.state";
import { AzureButton } from "@/components/common/AzureButton";
import { typesRequiredRegister } from "../../PreviewResult/data/preview-result.repository";
import { useHandleGenerateResult } from "@/hooks/useHandleGenerateResult";
import classes from "./TypesWithSignUp.module.scss";
import { VARIANT } from "@/constant";
import { everyTrue } from "@/helper/helper";
import Popover from "@/components/common/DefaultPopover";
import { HiOutlineMail } from "react-icons/hi";
import { FcGoogle } from "react-icons/fc";
import cn from "classnames";
import { useInView } from "react-intersection-observer";
const TypesWithSignUp = () => {
  const isMobile = useMediaQuery({
    query: "(max-width: 500px)"
  });
  const {
    ref,
    inView
  } = useInView();
  const {
    solutionsSelectedTypes
  } = useSolutionsSelect();
  const {
    setIsSignUpModal,
    setIsSignUpPopup,
    isSignUpModal
  } = useSignUpModal();
  const [downloadButtonWidth, setDownloadButtonWidth] = useState(340);
  const popoverRef = useRef<OverlayTriggerHandle>(null);
  const [setRegisterInPreview, setRegisterTrack] = useRegisterTrack(state => [state.setRegisterInPreview, state.setRegisterTrack]);
  const {
    handleGenerateResult
  } = useHandleGenerateResult();
  const t = useTranslations("QrTypes");
  const t2 = useTranslations("Home");
  const userState = useUserState();
  const TEST_VARIANT = userState.versionInfo["/"] ?? VARIANT.VariantA;
  const router = useRouter();
  const handleRegisterTrack = () => {
    if (solutionsSelectedTypes) setRegisterTrack(solutionsSelectedTypes);
  };
  useEffect(() => {
    handleGenerateResult(null);
  }, []);
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);
  useEffect(() => {
    handleScroll(); // for inView render
    if (!inView) {
      popoverRef.current?.close();
    }
    ;
  }, [inView]);
  const handleScroll = () => {
    if (popoverRef.current) {
      setDownloadButtonWidth(popoverRef.current?.root?.clientWidth || 340);
    }
  };
  function onEmail() {
    onClosePopover();
    setIsSignUpModal(true);
    handleRegisterTrack();
    if (everyTrue(TEST_VARIANT === VARIANT.VariantE, !router.pathname.includes("dashboard"))) {
      setRegisterInPreview(true);
    }
  }
  function onClosePopover() {
    if (popoverRef.current) {
      popoverRef.current?.close();
    }
  }
  function onOpenPopup() {
    setIsSignUpPopup(true);
  }
  async function onOpenPopupHandler(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    if (typesRequiredRegister.includes(solutionsSelectedTypes!)) {
      if (isMobile) {
        onClosePopover();
        onOpenPopup();
      }
      return;
    }
  }
  return <div className={classes.Wrapper} ref={ref} data-sentry-component="TypesWithSignUp" data-sentry-source-file="TypesWithSignUp.tsx">
      <div className={classes.Info}>
        <div className={classes.InfoContainer}>
          <div className={classes.Title}>{t(`${solutionsSelectedTypes}.title`)}</div>
          <p className={classes.Des}>{t(`${solutionsSelectedTypes}.description`)}</p>
        </div>
        <div className={classes.ButtonBox}>
          <Popover ref={popoverRef} placement={"bottom"} trigger={typesRequiredRegister.includes(solutionsSelectedTypes!) && !isMobile ? "click" : "none"} whisper={<button data-testid="downloadBtn" id="btn_qr_download_btn" className={cn(classes.DownloadBtn)} onClick={onOpenPopupHandler}>
                {isMobile ? t2("qrTypeSignUpBtnMobile") : t2("qrTypeSignUpBtn")}
              </button>} data-sentry-element="Popover" data-sentry-source-file="TypesWithSignUp.tsx">
            <div id="popover_wrapper" className={classes.PopoverDownload} style={{
            "--width": `${downloadButtonWidth}px`
          } as CSSProperties}>
              <ul>
                <li>
                  <a id="btn_continue_with_google" onClick={() => {
                  signIn("google");
                }} rel="noopener noreferrer">
                    <FcGoogle size={20} data-sentry-element="FcGoogle" data-sentry-source-file="TypesWithSignUp.tsx" />
                    {t2("ContinueWithGoogle")}
                  </a>
                </li>

                <li>
                  <AzureButton variant="ghost" onClick={() => {
                  signIn("azure-ad");
                }} text={t2("ContinueWithMicrosoft")} data-sentry-element="AzureButton" data-sentry-source-file="TypesWithSignUp.tsx" />
                </li>
                <li className={classes.WithEmail}>
                  <span id="btn_continue_with_email" onClick={onEmail}>
                    <HiOutlineMail size={22} color="#A1A1A1" data-sentry-element="HiOutlineMail" data-sentry-source-file="TypesWithSignUp.tsx" /> {t2("ContinueWithEmail")}
                  </span>
                </li>
              </ul>
            </div>
          </Popover>
        </div>
      </div>
    </div>;
};
export default TypesWithSignUp;